import React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { I18n, Translate } from 'react-redux-i18n';
import { Field, Form } from 'react-final-form';
import activationApi from '../../../network/api/activationApi';
import { getLinks } from '../../../network/api/links';
import Button from '../../common/Button';
import logo from '../../../img/logo-idnot.png';
import { validationMap } from '../../../network/api/types/compte/RequirementType';
import PasswordInput from '../../common/inputs/passwordInput/PasswordInput';
import Footer from '../../layout/Footer';
import { ACCOUNT_ALREADY_ACTIVATED, VERIFICATION_MAIL } from '../../../routes';
import Loader from '../../Loader';

type Props = RouteComponentProps<{key: string}>;
type State = {
  urlKey: string,
  displayForm: boolean,
  loading: boolean,
  sent: boolean,
  password: string,
  expired: boolean,
  errors: {message: string}[],
};

class ActivationLinkPage extends React.Component<Props, State> {
  state: State = {
    urlKey: this.props.match.params.key,
    displayForm: false,
    sent: false,
    password: null,
    expired: false,
    errors: [],
    loading: true,
  };

  componentDidMount() {
    this.checkToken();
  }

  checkToken = () => {
    activationApi.isValidToken({ value: this.state.urlKey })
      .then((response) => {
        if (response.value === 1) {
          this.setState({ displayForm: true, loading: false });
        } else this.send();
      })
      .catch((err) => {
        if (typeof err.then === 'function') {
          return err.then((e) => {
            this.setState({ errors: e.fieldErrors, loading: false });
            e.fieldErrors?.forEach((error) => {
              if (error.errorCode === 'ACTI_GP_02') {
                window.scrollTo(0, 0);
                this.setState({ expired: true, loading: false });
              }
            });
          });
        }
        return null;
      });
  };

  send = () => {
    activationApi.finish({
      key: this.state.urlKey,
      password: this.state.password,
    }).then((data) => {
      if (data.success) {
        window.scrollTo(0, 0);
        this.setState({ sent: true, loading: false });
        return;
      }
      if (data.status === 'ACTI_GP_06') {
        this.props.history.push(ACCOUNT_ALREADY_ACTIVATED);
      }
      this.setState({ errors: [{ message: data.message }], loading: false });
    }).catch((err) => {
      if (typeof err.then === 'function') {
        return err.then((e) => {
          this.setState({ errors: e.fieldErrors, loading: false });
          e.fieldErrors?.forEach((error) => {
            if (error.errorCode === 'ACTI_GP_02') {
              window.scrollTo(0, 0);
              this.setState({ expired: true, loading: false });
            }
          });
        });
      }
      return null;
    });
  };

  handleEdit = (values) => {
    this.setState({ password: values.password });
    this.send();
  };

  render() {
    return (
      <div className="activation-link-page">
        <div className="activation-header">
          <div className="label-container">
            <div className="main-content">
              <div>
                <img className="logo" src={logo} alt="logo" />
              </div>
              <div>
                <h3>
                  <Translate value="ACTIVATION.TITLE" />
                </h3>
                <div className="subtitle">
                  <Translate value="HEADER.UNIQUE_ACCOUNT" />
                </div>
              </div>
            </div>
          </div>
        </div>
        {
          this.state.loading && (<Loader />)
        }
        {
          !this.state.sent && this.state.displayForm && (
            <div>
              <div className="account-activation-col">
                <span><Translate value="ACTIVATION_LINK.MDP" /></span>
                <Form
                  onSubmit={this.handleEdit}
                  // initialValues={}
                  validate={(values) => {
                    const errors = {
                      password: null,
                      confirmPassword: null,
                    };
                    if (!validationMap.all(values.password)) {
                      errors.password = I18n.t('VALIDATION.PASSWORD.UNFIT');
                    }
                    if (validationMap.all(values.password)
                      && values.password !== values.confirmPassword) {
                      errors.confirmPassword = I18n.t('VALIDATION.PASSWORD.CONFIRM_DIFFERENT');
                    }
                    if (!errors.password && !errors.confirmPassword) {
                      return {};
                    }
                    return errors;
                  }}
                  render={(
                    {
                      handleSubmit,
                      submitError,
                      submitting,
                      values,
                    },
                  ) => (
                    <form className="connection-information-form" onSubmit={handleSubmit}>
                      {submitError && <div className="error">{submitError}</div>}
                      <div className="password-container">
                        <Field
                          name="password"
                          component={PasswordInput}
                          placeholder={I18n.t('ACTIVATION.PASSWORD')}
                          type="text"
                          withHelper
                          required
                        />
                        <Field
                          name="confirmPassword"
                          component={PasswordInput}
                          placeholder={I18n.t('ACTIVATION.CONFIRME')}
                          type="text"
                          required
                        />
                      </div>
                      <div className="button-container">
                        <Button
                          type="primary"
                          buttonType="submit"
                          i18nKey="actions.CONFIRM"
                          disabled={submitting
                          || values.password === null || values.confirmPassword === null}
                        />
                      </div>
                    </form>
                  )}
                />
              </div>
            </div>
          )
        }
        {this.state.expired
        && (
          <div className="email-page-content">
            <h3><Translate value="ACTIVATION_LINK.EXPIRED" /></h3>
            <Button
              type="primary"
              onClick={() => this.props.history.push({
                pathname: VERIFICATION_MAIL,
                state: { key: this.state.urlKey },
              })}
              i18nKey="ACTIVATION.RENSEND_EMAIL"
            />
          </div>
        )}
        {
          !this.state.displayForm
            && !this.state.expired
          && this.state.errors
            && this.state.errors.length > 0
          && this.state.errors.map((e) => <span key={e.message}>{e.message}</span>)
        }
        {
          this.state.sent && (
            <div className="email-page-content">
              <h3><Translate value="ACTIVATION_LINK.ACTIVATED" /></h3>
              <div className="back-button">
                <a
                  aria-label="Se connecter"
                  href={getLinks().connectionLink}
                >
                  <Button
                    type="third"
                    i18nKey="HEADER.CONNECTION"
                  />
                </a>
              </div>
            </div>
          )
        }
        <Footer />
      </div>
    );
  }
}
export default withRouter(ActivationLinkPage);
